export default __webpack_public_path__ + "static/media/miut_gutter_preview.93530fcd.png";